import { MaterialReactTable } from 'material-react-table'

import { PageWrap } from '@/components'
import { useTable } from '@/hooks'
import { useCheckStructureUsingGetQuery } from '@/rtkApi'
import { ValidationMessageDto } from '@/rtkApi/mddApiSliceGenerated'

import { useDetailTabContext } from '../DetailTab'
import { useValidationColumns } from './hooks'

export const NewValidation = () => {
	const {
		state: { editMode, node },
	} = useDetailTabContext()

	const { data: validation, isLoading } = useCheckStructureUsingGetQuery({
		structureId: node.id ?? 0,
	})

	const columns = useValidationColumns()

	const table = useTable<ValidationMessageDto>({
		columns,
		data: validation || [],
		editMode,
		options: {
			enableRowActions: false,
			enableRowOrdering: false,
			state: {
				isLoading,
			},
			enableTopToolbar: true,
			enableGlobalFilter: true,
		},
	})

	return (
		<PageWrap>
			<MaterialReactTable table={table} />
		</PageWrap>
	)
}
